import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchVatDeclarationById } from '../query-api'

interface UseVatDeclarationProps {
  vatDeclarationId?: string
  pollingEnabled?: boolean
}

const DEFAULT_POLLING_INTERVAL = 3000

export const useVatDeclaration = ({ vatDeclarationId, pollingEnabled = false }: UseVatDeclarationProps = {}) => {
  const { data, isLoading, isError } = useQuery(
    [QueryKeys.VatDeclarations, vatDeclarationId],
    () => fetchVatDeclarationById(vatDeclarationId || ''),
    {
      enabled: !!vatDeclarationId,
      cacheTime: pollingEnabled ? 0 : undefined,
      refetchInterval: pollingEnabled ? DEFAULT_POLLING_INTERVAL : false,
    },
  )

  return { vatDeclaration: data?.salesTaxReturn, isLoading, isError }
}
